import { ModelBase } from '../../core/model/model-base';
import { PostalAddress } from '../../common/model/postal-address';
import { MailStatus, MailStatusToString } from './const/enums';

export class Mail extends ModelBase {
  constructor() {
    super();

    this.recipientAddress = new PostalAddress();
    this.senderAddress = new PostalAddress();
    this.status = MailStatus.Created;
  }

  private _sendDate: Date;

  body: string;
  footer: string;
  header: string;
  recipientAddress: PostalAddress;
  senderAddress: PostalAddress;
  get sendDate(): Date {
    return this._sendDate;
  }
  set sendDate(value: Date) {
    this._sendDate = this.coerceDate(value);
  }

  status: MailStatus;

  get statusCaption(): string {
    return MailStatusToString(this.status);
  }
}
